<template>
  <div class="absolute top-0 left-0 h-full w-full object-cover">
    <video-js
      ref="playerRef"
      class="video-js absolute top-0 left-0 h-full w-full object-cover"
    />
    <slot v-if="!poster && showBtnPlay" />
    <img
      v-if="poster && showBtnPlay"
      :src="poster"
      :alt="heading"
      class="absolute top-0 left-0 w-full h-full object-cover"
    >
    <div class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
      <button
        v-if="showBtnPlay"
        class="w-16 h-16 flex bg-white items-center justify-center rounded-full shadow focus:outline-none focus:bg-beige"
        @click="onHandleClick"
      >
        <span class="icon-play" />
      </button>
    </div>
  </div>
</template>

<script>
import {
  onBeforeUnmount, onMounted, ref, computed
} from 'vue'
import 'video.js/dist/video-js.css'
import videojs from 'video.js'

export default {
  props: {
    model: {
      type: String,
      required: true
    },
    poster: {
      type: String,
      default: ''
    },
    autoplay: {
      type: Boolean,
      default: false
    },
    loop: {
      type: Boolean,
      default: false
    },
    muted: {
      type: Boolean,
      default: true
    },
    controls: {
      type: Boolean,
      default: false
    },
    playsinline: {
      type: Boolean,
      default: true
    },
    heading: {
      type: String,
      default: 'Default'
    }
  },
  setup(props) {
    let player
    const playerRef = ref()
    const showBtnPlay = ref(true)
    const observer = ref(null)

    const videoOptions = computed(() => {
      const {
        muted,
        controls,
        playsinline
      } = props

      return {
        autoplay: false, // Ensure all videos are paused on load
        muted,
        controls,
        liveui: controls,
        playsinline,
        loop: props.autoplay ? 'true' : false,
        sources: [
          {
            src: props.model,
            type: 'application/x-mpegURL'
          }
        ]
      }
    })

    const onHandleClick = () => {
      player.play()
    }

    onMounted(() => {
      player = videojs(playerRef.value, videoOptions.value)

      // Handle the 'ended' event to restart the video if loop is true
      player.on('ended', () => {
        if (props.loop) {
          player.one('ended', () => {
            player.currentTime(0)
            player.play()
          })
        }
      })

      // Setup Intersection Observer
      observer.value = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            player.play()
            showBtnPlay.value = false
          } else {
            player.pause()
            showBtnPlay.value = true
          }
        })
      }, {
        threshold: 0.5 // Play the video when 50% or more is visible
      })

      observer.value.observe(playerRef.value)

      // Ensure the video is paused on initial load
      player.ready(() => {
        player.pause()
      })
    })

    onBeforeUnmount(() => {
      if (player) {
        player.dispose()
      }
      if (observer.value) {
        observer.value.disconnect()
      }
    })

    return {
      playerRef,
      showBtnPlay,
      onHandleClick
    }
  }
}
</script>

<style>
.video-js .vjs-big-play-button {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.video-js .vjs-tech {
  object-fit: cover;
}
</style>
